import { getRandom, tsParticles } from "@tsparticles/engine";
let initialized = false;
let initPromise;
let initCallback;
async function initParticlesEngine(init) {
    if (initialized) {
        return;
    }
    if (initPromise) {
        if (initCallback !== init) {
            throw new Error("initParticlesEngine callback must be stable across the app lifecycle.");
        }
        await initPromise;
        return;
    }
    initCallback = init;
    initPromise = (async () => {
        if (init) {
            await init(tsParticles);
        }
        await tsParticles.init();
        initialized = true;
    })().catch((error) => {
        initPromise = undefined;
        initCallback = undefined;
        initialized = false;
        throw error;
    });
    await initPromise;
}
function isParticlesEngineInitialized() {
    return initialized;
}
async function waitForParticlesEngineInitialization() {
    await (initPromise ?? Promise.resolve());
}
const containers = new WeakMap();
$.fn.particles = function () {
    const baseId = "tsparticles";
    const load = (options) => {
        const promises = [];
        this.each((index, element) => {
            if (element.id === undefined) {
                element.id = baseId + Math.floor(getRandom() * 1000);
            }
            const p = (async () => {
                if (!initPromise) {
                    initParticlesEngine();
                }
                await waitForParticlesEngineInitialization();
                if (!isParticlesEngineInitialized()) {
                    throw new Error("$.particles.init(...) must be called once before rendering jQuery particles.");
                }
                const container = await tsParticles.load({ id: element.id, options });
                if (container) {
                    containers.set(element, container);
                }
                return container;
            })();
            promises.push(p);
        });
        return Promise.all(promises).then(list => (list.length > 0 ? list[0] : undefined));
    };
    const ajax = (jsonUrl) => {
        const promises = [];
        this.each((index, element) => {
            if (element.id === undefined) {
                element.id = baseId + Math.floor(getRandom() * 1000);
            }
            const p = (async () => {
                await waitForParticlesEngineInitialization();
                if (!isParticlesEngineInitialized()) {
                    throw new Error("$.particles.init(...) must be called once before rendering jQuery particles.");
                }
                const container = await tsParticles.load({ id: element.id, url: jsonUrl });
                if (container) {
                    containers.set(element, container);
                }
                return container;
            })();
            promises.push(p);
        });
        return Promise.all(promises).then(list => (list.length > 0 ? list[0] : undefined));
    };
    const setTheme = async (theme) => {
        for (const element of this) {
            const container = containers.get(element);
            if (container) {
                await container.loadTheme?.(theme);
            }
        }
    };
    return { load, ajax, setTheme };
};
$.particles = function () {
    const init = (init) => initParticlesEngine(init);
    return { init };
};
